import { takeEvery, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import get from 'lodash/get'

import { showInfo } from 'store/entities/toastr/utils'
import { isResponseFailed } from 'helpers/responseHelpers'
import { subscribeToProTrack } from 'store/entities/identity/actions'
import { onBoarding } from '../actions'

export function* handleChangeProTrack({ payload: { proTrackLevelId } }) {
  yield put(onBoarding.changeIsLoading(true))
  const response = yield subscribeToProTrack.call({ proTrackLevelId })
  yield put(onBoarding.changeIsLoading(false))
  if (!isResponseFailed(response)) {
    yield put(push('/dashboard'))
  } else {
    showInfo({ content: get(response, ['error', 'message'], 'An error occurred, please try again') })
  }
}

export default function* changeProTrackEvery() {
  yield takeEvery(onBoarding.changeProTrack.toString(), handleChangeProTrack)
}
